
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class ProductionBOMGrid extends Serenity.EntityGrid<ProductionBOMRow, any> {
        protected getColumnsKey() { return 'Production.ProductionBOM'; }
        protected getDialogType() { return ProductionBOMDialog; }
        protected getIdProperty() { return ProductionBOMRow.idProperty; }
        protected getInsertPermission() { return ProductionBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductionBOMRow.localTextPrefix; }
        protected getService() { return ProductionBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}